module.exports = __webpack_public_path__ + "static/media/dog.cf360348.jpg";